/*
 * OB TIE DYE — WEBSITE FEED EXPANDER
 * ------------------------------------------------------------
 * Shopify stores one compact row per sheet record.
 * This expands recurring rows into concrete dates in the browser.
 * Edit recurrence data in Event Guide Master, not here.
 * ------------------------------------------------------------
 */
(function(){
  'use strict';
  var TZ=window.OB_GUIDE_TZ||'America/Los_Angeles', HORIZON_DAYS=140;
  var DAY={mon:1,monday:1,tue:2,tues:2,tuesday:2,wed:3,wednesday:3,thu:4,thur:4,thurs:4,thursday:4,fri:5,friday:5,sat:6,saturday:6,sun:0,sunday:0};

  function pad(n){return String(n).padStart(2,'0')}
  function normDate(v){var m=String(v||'').match(/(\d{4})-(\d{2})-(\d{2})/);return m?m[1]+'-'+m[2]+'-'+m[3]:''}
  function parseDate(s){var m=normDate(s).match(/(\d{4})-(\d{2})-(\d{2})/);return m?new Date(Date.UTC(+m[1],+m[2]-1,+m[3],12)):null}
  function dateKey(d){return d.getUTCFullYear()+'-'+pad(d.getUTCMonth()+1)+'-'+pad(d.getUTCDate())}
  /* Speed (Sep 25 2026): date keys repeat thousands of times, so next-day and weekday answers are remembered */
  var AD={},DW={};
  function addDays(key,n){var ck=key+'|'+n;if(ck in AD)return AD[ck];var d=parseDate(key);if(!d)return (AD[ck]='');d.setUTCDate(d.getUTCDate()+n);return (AD[ck]=dateKey(d))}
  function compare(a,b){return String(a).localeCompare(String(b))}
  function minDate(a,b){if(!a)return b;if(!b)return a;return compare(a,b)<=0?a:b}
  function todayKey(){
    var p=new Intl.DateTimeFormat('en-CA',{timeZone:TZ,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()),v={};
    p.forEach(function(x){v[x.type]=x.value});return v.year+'-'+v.month+'-'+v.day;
  }
  function dow(key){if(key in DW)return DW[key];var d=parseDate(key);return (DW[key]=d?d.getUTCDay():-1)}
  function parseDays(v){
    if(!v)return null;var out=[];
    var parts=String(v).split(',');
    for(var i=0;i<parts.length;i++){
      var k=parts[i].toLowerCase().replace(/[^a-z]/g,'');
      if(DAY[k]===undefined)return null;
      if(out.indexOf(DAY[k])===-1)out.push(DAY[k]);
    }
    return out;
  }
  /* Sep 25 2026: the Days column is often written in plain words ("Daily", "Wed-Sun",
     "1st Fri", "Oct 3-4, 10-11", "Weekends in October"). parseDays only reads a comma list
     of weekdays, so those rows used to show on their first date and then drop off the site.
     readDays returns {dates:[...]} for listed dates, {test:fn} for a weekly or monthly pattern,
     or null when the wording can't be read ("Select nights"): the row then shows as one run
     from its start to its end date. */
  var MONTHS={jan:1,feb:2,mar:3,apr:4,may:5,jun:6,jul:7,aug:8,sep:9,sept:9,oct:10,nov:11,dec:12};
  var ORD={'1st':1,first:1,'2nd':2,second:2,'3rd':3,third:3,'4th':4,fourth:4,last:-1};
  var WDX='(mon|tue|tues|wed|thu|thur|thurs|fri|sat|sun)[a-z]*';
  function wd(tok){var k=String(tok||'').toLowerCase().replace(/[^a-z]/g,'');for(var n in DAY)if(k===n||k.indexOf(n)===0&&n.length>=3)return DAY[n];return -1}
  function readDays(v,startKey){
    var s=' '+String(v||'').toLowerCase().replace(/[–—]/g,'-')+' ';
    if(!s.trim()||/\bselect\b/.test(s))return null;
    if(/\bweekends?\b/.test(s))return {test:function(k){var d=dow(k);return d===0||d===6}};
    var om=s.match(new RegExp('\\b(1st|2nd|3rd|4th|first|second|third|fourth|last)\\s+'+WDX+'\\b'));
    if(om){var n=ORD[om[1]],want=wd(om[2]);return {test:function(k){if(dow(k)!==want)return false;var day=+k.slice(8);if(n===-1)return addDays(k,7).slice(5,7)!==k.slice(5,7);return Math.ceil(day/7)===n}}}
    var rx=/\b(jan|feb|mar|apr|may|jun|jul|aug|sept|sep|oct|nov|dec)[a-z]*\.?\s+((?:\d{1,2}(?:\s*-\s*\d{1,2})?(?![\d\s\-]*(?:am|pm|a\.m|p\.m|:))(?:\s*(?:,|&|and)\s*(?=\d))?)+)/g,m,out=[];
    var y0=+String(startKey).slice(0,4),m0=+String(startKey).slice(5,7);
    while((m=rx.exec(s))){
      var mo=MONTHS[m[1]],yr=mo<m0-1?y0+1:y0;
      m[2].split(/\s*(?:,|&|and)\s*/).forEach(function(part){
        var r=part.match(/^(\d{1,2})(?:\s*-\s*(\d{1,2}))?$/);if(!r)return;
        for(var d=+r[1];d<=+(r[2]||r[1])&&d<=31;d++){var k=yr+'-'+pad(mo)+'-'+pad(d);if(normDate(addDays(k,0))===k)out.push(k)}
      });
    }
    if(out.length)return {dates:out};
    if(/\b(daily|nightly|every day|everyday)\b/.test(s))return {test:function(){return true}};
    var set=[],rr=new RegExp('\\b'+WDX+'(?:\\s*-\\s*'+WDX+')?','g'),w;
    while((w=rr.exec(s))){
      var a=wd(w[1]),b=w[2]?wd(w[2]):a;if(a<0||b<0)continue;
      for(var i=0,x=a;i<7;i++,x=(x+1)%7){if(set.indexOf(x)===-1)set.push(x);if(x===b)break}
    }
    if(set.length)return {test:function(k){return set.indexOf(dow(k))!==-1}};
    return null;
  }
  function parseTime(v){var m=String(v||'').trim().match(/^(\d{1,2}):(\d{2})$/);if(!m)return null;return {h:+m[1],m:+m[2]}}
  /* Speed (Sep 22 2026): one shared formatter instead of a new one per call, and each
     date + time is converted once. Recurring rows repeat the same times hundreds of times,
     so this took the page's startup work from about a second to a few milliseconds.
     The math is unchanged. */
  var ZFMT=new Intl.DateTimeFormat('en-US',{timeZone:TZ,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}),ZCACHE={};
  function zoneOffset(ms){var p=ZFMT.formatToParts(new Date(ms)),v={};p.forEach(function(x){v[x.type]=x.value});var asUTC=Date.UTC(+v.year,+v.month-1,+v.day,+v.hour,+v.minute);return asUTC-ms}
  function zonedMs(dateStr,timeStr){
    var d=normDate(dateStr),ck=d+'|'+timeStr;
    if(ck in ZCACHE)return ZCACHE[ck];
    var t=parseTime(timeStr);if(!d||!t)return (ZCACHE[ck]=NaN);
    var a=d.split('-').map(Number),guess=Date.UTC(a[0],a[1]-1,a[2],t.h,t.m);
    var ms=guess-zoneOffset(guess);ms=guess-zoneOffset(ms);return (ZCACHE[ck]=ms);
  }
  function iso(dateStr,timeStr){var ms=zonedMs(dateStr,timeStr);return isNaN(ms)?'':new Date(ms).toISOString()}
  function endDateFor(raw,occDate){
    var baseStart=normDate(raw.start_date),baseEnd=normDate(raw.end_date),out=occDate;
    var overnight=raw.end_time&&raw.start_time&&raw.end_time<=raw.start_time;
    /* Repeating rows (Sep 24 2026): start_date..end_date is the season (an exhibit open daily
       Aug 21 to Jan 25), not the length of one visit. Each occurrence runs its own hours and
       only crosses midnight when it ends before it starts (karaoke 8pm to 1am). */
    if(raw.recurring){if(overnight)out=addDays(occDate,1);return out}
    if(baseStart&&baseEnd&&compare(baseEnd,baseStart)>0){
      var a=parseDate(baseStart),b=parseDate(baseEnd);out=addDays(occDate,Math.round((b-a)/86400000));
    }else if(overnight){out=addDays(occDate,1)}
    return out;
  }
  function make(raw,d){
    var allDay=!String(raw.start_time||'').trim();
    var start=iso(d,allDay?'00:00':raw.start_time);if(!start)return null;
    var end='';
    if(raw.end_time)end=iso(endDateFor(raw,d),raw.end_time);
    else if(allDay)end=iso(endDateFor(raw,d),'23:59');
    return {key:(raw.recurring?String(raw.key||'')+'|'+d:String(raw.key||'')),title:raw.title||'',cat:raw.cat||'',start:start,end:end||null,all_day:allDay,place:raw.place||'',hood:raw.hood||'',desc:raw.desc||'',image:raw.image||'',url:raw.url||'',here:!!raw.here,starred:!!raw.starred,region:raw.region||'',worth_drive:!!raw.worth_drive,tags:Array.isArray(raw.tags)?raw.tags:[],pick_note:raw.pick_note||''};
  }
  function expand(rows){
    var today=todayKey(),horizon=addDays(today,HORIZON_DAYS),out=[],seen={};
    (rows||[]).forEach(function(raw){
      if(!raw||!raw.title||!raw.cat||!raw.start_date)return;
      var start=normDate(raw.start_date);if(!start)return;
      var dates=[];
      if(raw.recurring){
        var days=parseDays(raw.days),cap=minDate(normDate(raw.active_through)||(normDate(raw.end_date)>start?normDate(raw.end_date):''),horizon)||horizon;
        var yesterday=addDays(today,-1),from=compare(start,yesterday)>0?start:yesterday,rd=days?null:readDays(raw.days,start);
        if(days){
          var d=from;
          while(compare(d,cap)<=0){if(days.indexOf(dow(d))!==-1)dates.push(d);d=addDays(d,1)}
        }else if(rd&&rd.dates){
          rd.dates.forEach(function(k){if(compare(k,from)>=0&&compare(k,cap)<=0&&dates.indexOf(k)===-1)dates.push(k)});
        }else if(rd&&rd.test){
          var d2=from;
          while(compare(d2,cap)<=0){if(rd.test(d2))dates.push(d2);d2=addDays(d2,1)}
        }else{
          /* wording we can't read: one run from start to end, shown as ongoing */
          var runEnd=normDate(raw.active_through)||normDate(raw.end_date);
          if(runEnd&&compare(runEnd,start)>0){raw=Object.assign({},raw,{recurring:false,end_date:runEnd});if(compare(runEnd,today)>=0)dates=[start]}
          else if(compare(start,today)>=0){dates=[start]}
        }
      }else{
        var finalDate=normDate(raw.end_date)||start;
        if(compare(finalDate,today)>=0)dates=[start]
      }
      if(!dates.length)return;
      /* accents are ignored (Sep 25 2026), so "Día" and "Dia" count as the same event.
         The row's text is the same on every date, so it is cleaned once per row. */
      var norm=function(v){v=String(v||'');if(v.normalize)v=v.normalize('NFD').replace(/[̀-ͯ]/g,'');return v.toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()};
      var cat=norm(raw.cat),venue=norm(raw.place);
      // Trivia and karaoke listings commonly arrive with different titles from different calendars.
      // Collapse only identical venue + occurrence date + start time + category; keep other events distinct.
      var label=(cat==='trivia'||cat==='karaoke')?cat:norm(raw.title)+'|'+cat;
      dates.forEach(function(d){
        var item=make(raw,d);if(!item)return;
        var k=venue+'|'+d+'|'+item.start+'|'+label;
        if(item.end&&Date.parse(item.end)<=Date.now())return;
        if(!seen[k]){seen[k]=1;out.push(item)}
      });
    });
    /* sort on numbers worked out once, instead of re-reading two dates on every comparison */
    var ms=out.map(function(x,i){return {t:Date.parse(x.start),i:i}});ms.sort(function(a,b){return a.t-b.t||a.i-b.i});
    return ms.map(function(m){return out[m.i]});
  }
  window.OB_GUIDE_EXPAND_RAW=expand;
})();

/* Compact filter rail enhancement */
(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};

  function sectionFor(selector){var el=$(selector);return el&&el.closest?el.closest('.og-side-section'):null}
  function labelFromMulti(section){var x=section&&section.querySelector('.og-multi-btn-label');return x?x.textContent.replace(/\s+/g,' ').trim():''}
  function quickLabel(){var active=$('#quickPickBar [data-quick][aria-pressed="true"]');return active?active.textContent.replace(/\s+/g,' ').trim():'All'}
  function selectedText(select){if(!select||select.selectedIndex<0)return'All';return select.options[select.selectedIndex].textContent.trim()}
  function dateLabel(){var open=$('#openNowChip');if(open&&open.getAttribute('aria-pressed')==='true')return'Open now';var active=$('.og-date-presets [data-quick][aria-pressed="true"]');return active?active.textContent.replace(/\s+/g,' ').trim():selectedText($('#dateSelect'))}

  function makeCollapsible(section,statusId){
    if(!section||section.classList.contains('og-compact-collapse'))return;
    var heading=section.querySelector('.og-side-heading');if(!heading)return;
    section.classList.add('og-compact-collapse');
    if(heading.tagName==='LABEL')heading.removeAttribute('for');
    heading.setAttribute('role','button');heading.setAttribute('tabindex','0');heading.setAttribute('aria-expanded','false');
    var status=document.createElement('span');status.className='og-compact-status';status.id=statusId;heading.appendChild(status);
    function toggle(){var open=section.classList.toggle('is-open');heading.setAttribute('aria-expanded',open?'true':'false')}
    heading.addEventListener('click',function(e){e.preventDefault();toggle()});
    heading.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle()}});
  }

  function sync(){
    var cat=$('#catSelect'),hood=$('#hoodSelect');
    var cs=$('#categoryStatus');if(cs)cs.textContent=quickLabel();
    var eventSection=sectionFor('#catSelect'),es=$('#eventTypeStatus');if(es)es.textContent=labelFromMulti(eventSection)||selectedText(cat);
    var hoodSection=sectionFor('#hoodSelect'),ns=$('#neighborhoodStatus');if(ns)ns.textContent=labelFromMulti(hoodSection)||(hood&&hood.value!=='all'?selectedText(hood):'All');
    var ds=$('#dateStatus');if(ds)ds.textContent=dateLabel();
  }

  function init(){
    var search=$('.og-side-search');
    if(search){var input=$('#guideSearch');if(input){input.value='';input.dispatchEvent(new Event('input',{bubbles:true}))}search.remove()}
    var hint=$('.og-ob-only-hint');if(hint)hint.remove();
    makeCollapsible(sectionFor('#quickPickBar'),'categoryStatus');
    makeCollapsible(sectionFor('#catSelect'),'eventTypeStatus');
    makeCollapsible(sectionFor('#hoodSelect'),'neighborhoodStatus');
    makeCollapsible(sectionFor('#dateSelect'),'dateStatus');
    document.addEventListener('click',function(){setTimeout(sync,0)},true);
    document.addEventListener('change',function(){setTimeout(sync,0)},true);
    window.addEventListener('popstate',function(){setTimeout(sync,0)});
    sync();
  }

  if(document.readyState==='complete')setTimeout(init,0);else window.addEventListener('load',init,{once:true});
})();

/* Real photos on OB Tie Dye vending cards + Ocean Beach Farmers Market */
(function(){
  'use strict';
  var photos=['https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-vending-customer-shopping.webp?v=1789665530','https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-pacific-beach-fest-crowd.webp?v=1789665538','https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-adams-avenue-street-fair.webp?v=1789665548','https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-san-diego-made-market-display.webp?v=1789665559'];
  var OB_FARMERS='https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-san-diego-events-ocean-beach-farmers-market_40292f00-3ac4-4b7d-a720-0376c82e922e.webp?v=1789667607';
  function norm(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim()}
  function hash(s){var h=0;for(var i=0;i<s.length;i++)h=(h*31+s.charCodeAt(i))>>>0;return h}
  function isObFarmersMarket(card){
    var t=norm(card&&card.textContent);
    return /(^| )ob farmers market( |$)/.test(t)||/(^| )ocean beach farmers market( |$)/.test(t)||/(^| )ocean beach community open market( |$)/.test(t);
  }
  function photoFor(card){
    var t=norm(card.textContent);
    if(isObFarmersMarket(card))return OB_FARMERS;
    if(/palm springs|pride/.test(t))return photos[0];
    if(/pacific beachfest|beachfest/.test(t))return photos[1];
    if(/adams avenue/.test(t))return photos[2];
    if(/san diego made/.test(t))return photos[3];
    return photos[hash(t)%photos.length];
  }
  function installStyle(){
    if(document.getElementById('ob-real-vending-photo-style'))return;
    var st=document.createElement('style');st.id='ob-real-vending-photo-style';
    st.textContent='\n'+
      '#ob-guide .og-card.og-obtd>.og-visual.ob-has-real-photo,#ob-guide .og-card.og-ob-farmers-photo>.og-visual.ob-has-real-photo{height:132px!important;min-height:132px!important;max-height:132px!important;flex:0 0 132px!important;position:relative!important;overflow:hidden!important;background:#d8e1e3!important;}\n'+
      '#ob-guide .og-pick-card>.og-visual.ob-has-real-photo{height:156px!important;min-height:156px!important;max-height:156px!important;position:relative!important;overflow:hidden!important;background:#d8e1e3!important;}\n'+
      '#ob-guide .og-visual.ob-has-real-photo>.og-ob-real-photo{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;object-fit:cover!important;display:block!important;z-index:0!important;}\n'+
      '#ob-guide .og-visual.ob-has-real-photo>.og-ob-real-overlay{position:absolute!important;inset:0!important;background:linear-gradient(180deg,rgba(7,24,35,.02) 35%,rgba(7,24,35,.68) 100%)!important;z-index:1!important;pointer-events:none!important;}\n'+
      '#ob-guide .og-visual.ob-has-real-photo>.og-visual-logo,#ob-guide .og-visual.ob-has-real-photo>.og-visual-icon{display:none!important;}\n'+
      '#ob-guide .og-visual.ob-has-real-photo>.og-visual-place{position:absolute!important;left:16px!important;right:16px!important;bottom:10px!important;z-index:2!important;color:#fff!important;text-shadow:0 1px 6px rgba(0,0,0,.35)!important;}\n'+
      '@media(max-width:700px){#ob-guide .og-card.og-obtd>.og-visual.ob-has-real-photo,#ob-guide .og-card.og-ob-farmers-photo>.og-visual.ob-has-real-photo{height:118px!important;min-height:118px!important;max-height:118px!important;flex-basis:118px!important;}#ob-guide .og-pick-card>.og-visual.ob-has-real-photo{height:140px!important;min-height:140px!important;max-height:140px!important;}}';
    document.head.appendChild(st);
  }
  function decorateVisual(card,visual){
    if(!visual)return;
    var src=photoFor(card),farmers=isObFarmersMarket(card),existing=visual.querySelector('.og-ob-real-photo');
    if(existing){
      if(existing.getAttribute('src')!==src)existing.setAttribute('src',src);
      existing.alt=farmers?'Ocean Beach Farmers Market in San Diego':'OB Tie Dye at a Southern California market';
      return;
    }
    var img=document.createElement('img');img.className='og-ob-real-photo';img.alt=farmers?'Ocean Beach Farmers Market in San Diego':'OB Tie Dye at a Southern California market';img.loading='lazy';img.decoding='async';img.src=src;
    var overlay=document.createElement('span');overlay.className='og-ob-real-overlay';overlay.setAttribute('aria-hidden','true');
    visual.insertBefore(img,visual.firstChild);visual.appendChild(overlay);visual.classList.add('ob-has-real-photo');
  }
  function decorate(){
    var root=document.getElementById('ob-guide');if(!root)return;
    root.querySelectorAll('.og-card').forEach(function(card){if(isObFarmersMarket(card)){card.classList.add('og-ob-farmers-photo');decorateVisual(card,card.querySelector('.og-visual'))}});
    root.querySelectorAll('.og-card.og-obtd').forEach(function(card){decorateVisual(card,card.querySelector('.og-visual'))});
    root.querySelectorAll('.og-pick-card').forEach(function(card){decorateVisual(card,card.querySelector('.og-visual'))});
  }
  function init(){installStyle();decorate();var root=document.getElementById('ob-guide');if(root)new MutationObserver(function(){decorate()}).observe(root,{childList:true,subtree:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

